// extracted by mini-css-extract-plugin
export default {"filter-inner":"contact-board_page_filter-inner__01fBo","button-container":"contact-board_page_button-container__XukYZ","table-container":"contact-board_page_table-container__O0pUP"};